import {PlayerReduxDispatch, PlayerReduxState} from "../types";
import {getBackFromAction} from "../selectors";
import {analyticsSendEvent} from "../../../libs/analytics";

export default function back() {
  return (dispatch: PlayerReduxDispatch, getState: () => PlayerReduxState) => {
    const state = getState();
    const backFrom = getBackFromAction(state);

    if (!backFrom) {
      console.warn("back: wrong state");
      return;
    }

    analyticsSendEvent("playerRepeat", {
      sessionId: state.sessionId!,
      repeatFromId: backFrom.id
    });

    dispatch({
      type: "back",
      payload: {
        "actionId": backFrom.id,
      }
    });
  }
}
